import React from "react";

const FeesAndCharges = ({ data }) => {
  return (
    <div className="border-solid border-[1px] border-[#000000] w-[95vw]  h-[100%] rounded-[10px] bg-[#ffffff] p-4 mx-4">
      <div className="flexflex-col justify-center pb-2">
        <p className="text-base font-semibold text-black">Fees And Charges</p>
      </div>

      <div className=" grid grid-cols-2 gap-2">
        {data.map((item) => (
          <div className="">
            <p className="font-medium text-sm font-montserra text-black">
              {item.title}
            </p>
            <p className="font-medium text-sm font-montserra text-black">
              {item.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeesAndCharges;
